import React from "react"
import Page from "../components/page";
import RatingsGrid from "../components/ratingsgrid";
import { Link } from "gatsby";

const IndexPage = (props) => {
  const pageTitle="College Basketball Ratings by Expected Point Margin | CBB Ratings"
  const seoDescription="Independent college basketball ratings for NCAA men's teams, based on expected point margins and updated daily. Includes today's matchups and full methodology."
  const pageHeading="College Basketball Ratings"
  return (
    <Page location={props.location.href} pageTitle={pageTitle} seoDescription={seoDescription} pageHeading={pageHeading}>
      <p>
        <Link to="/">CBB Ratings</Link> provides an objective, data-driven measure of NCAA men's college basketball team strength, expressed as expected point margins rather than ordinal ranks.
        <br/>
        Learn more about the <Link to="/methodology">rating methodology</Link> or see how <Link to="/today">today's ratings apply to upcoming matchups</Link>.
      </p>      

      <RatingsGrid season="2526" />
    </Page>
    );
};
export default IndexPage;